app.service('accountingService', function ($http) {

  
  // Routes | Accounts Receivables |-----------------------------------------

  this.getAccountingStatus_1 = function (obj) {
    return $http.post(`/accounting/getAccountingStatus_1`, obj)
      .then(function (response) {
        return response
      })
  }
  //-------------------------------------------------
  
  
  // Routes | Manual Payments |-----------------------------------------
  
  this.createPaymentRecord = function (obj) {
    return $http.post(`/accounting/createPaymentRecord`, obj)
      .then(function (response) {
        return response
      })
  }

  this.getGoldClients = function (obj) {
    return $http.post(`/accounting/getGoldClients`, obj)
      .then(function (response) {
        return response
      })
  }

  // Posts every check for one account and sends a single confirmation covering
  // them, rather than one email per check.
  this.postCheckBatch = function (obj) {
    return $http.post(`/accounting/postCheckBatch`, obj)
      .then(function (response) {
        return response
      })
  }

  // Permanently deletes a user's past-due penalty rows for the billing period.
  this.removeInterest = function (obj) {
    return $http.post(`/accounting/removeInterest`, obj)
      .then(function (response) {
        return response
      })
  }

  //-------------------------------------------------

})